var Userpage = function() {
    var handle_btn_click = function() {
        $('.ii__votes_btn').click(function() {
            var btn = $(this);
            Ajax.getUserVotes(
                btn.data('total'),
                btn.data('vpp'),
                btn.data('page'),
                btn.data('uid'),
                function(res) {
                    if (res && res.success == 'ok' && res.html) {
                        $('#votes_table_container').replaceWith(res.html);
                        handle_btn_click();
                    }
                });
        });
    };
    var handle_vote_delete = function() {
        $('.ii__del_vote').click(function() {
            Ajax.delVote($(this).data('vid'), function() {
                top.location.href = top.location.href;
            });
        });
    };
    return {
        init: function() {
            handle_btn_click();
            handle_vote_delete();
        }
    };
}();
